import { render } from "./playerDetail.vue?vue&type=template&id=32bd0678&scoped=true"
import script from "./playerDetail.vue?vue&type=script&lang=js"
export * from "./playerDetail.vue?vue&type=script&lang=js"

import "./playerDetail.vue?vue&type=style&index=0&id=32bd0678&scoped=true&lang=css"
import "./playerDetail.vue?vue&type=style&index=1&id=32bd0678&lang=css"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bd0678"]])

export default __exports__